import React, {Component, useEffect} from 'react';
import axios from 'axios';
import './register.scss';
import AuthService from "../../services/authService";
import logo from '../../assets/images/happily-ever-after_m365_WHITE.png';
import {Link} from 'react-router-dom';
import ReactGA from 'react-ga';


class Register extends Component {
    constructor(props) {
        super(props);
        this.state = {
            registered: true,
            key_valid: false,
            license_key_error: false,
            license_key_error_msg: '',
            license_key_value: '',
            registration_error_msg: '',
            registration_error: false,
            registration_form_errors: {
                first_name: '',
                last_name: '',
                password: '',
                password_confirmation: '',
                email: '',
            }
        };
        ReactGA.initialize('UA-71072433-1');
        this.convertToUppercase = this.convertToUppercase.bind(this);

    }



    componentDidMount() {
        if (this.props.match.params.lk) {
            let {lk} = this.props.match.params;
            this.setState({
                license_key_value: lk
            })
        }
    }

    maxLicenseKeyLimit = 8;


    getFormData(event) {
        event.preventDefault();
        // console.log("event form", event.currentTarget);
        let email = document.getElementById("register-id").value;
        let password = document.getElementById("register-password").value;
        let first_name = document.getElementById("first-name").value;
        let last_name = document.getElementById("last-name").value;
        let password_confirmation = document.getElementById("confirm-password").value;
        let license_key = this.state.license_key_value
        let registerObj = {
            email,
            password,
            first_name,
            last_name,
            password_confirmation,
            license_key
        }
        // console.log("registerObj", registerObj);
        this.sendData(registerObj);
    }

    async sendData(registerObj) {
        this.setState({
            registration_form_errors: {}
        })
        let dataURL = "https://onamfc.com/api/signup";
        await axios.post(dataURL, registerObj).then(response => {
            AuthService.setToken(response.data.token);
            AuthService.setUser(response.data.user);
            ReactGA.event({category: 'user', action: 'registered'});
            this.props.history.replace('/welcome');
            this.loginSuccess();
        }).catch(er => {
            // console.log(er.response)
            this.setState({
                registration_form_errors: {
                    email: er.response.data.error.errors.email ? er.response.data.error.errors.email.shift() : '',
                    first_name: er.response.data.error.errors.first_name ? er.response.data.error.errors.first_name.shift() : '',
                    last_name: er.response.data.error.errors.last_name ? er.response.data.error.errors.last_name.shift() : '',
                    password: er.response.data.error.errors.password ? er.response.data.error.errors.password.shift() : '',
                    password_confirmation: er.response.data.error.errors.password_confirmation ? er.response.data.error.errors.password_confirmation.shift() : ''
                }
            })
        });
    }

    loginSuccess () {
        gtag('event', 'conversion', {

            'send_to': 'AW-669061262/y2XGCOLs2sIBEI6hhL8C',

            'value': 97.0,

            'currency': 'USD',

            'transaction_id': ''

        });
    }

    generateForm() {
        return (
            <form id="register-form" onSubmit={this.getFormData.bind(this)}>
                <div className="form__field">
                    <label>First Name</label>
                    <input id="first-name" type="text" name="first-name"/>
                    {
                        this.state.registration_form_errors.first_name &&
                        <div className="error">{this.state.registration_form_errors.first_name}</div>
                    }
                </div>
                <div className="form__field">
                    <label>Last Name</label>
                    <input id="last-name" type="text" name="last-name"/>
                    {
                        this.state.registration_form_errors.last_name &&
                        <div className="error">{this.state.registration_form_errors.last_name}</div>
                    }
                </div>
                <div className="form__field">
                    <label>Email</label>
                    <input id="register-id" type="text" name="email"/>
                    {
                        this.state.registration_form_errors.email &&
                        <div className="error">{this.state.registration_form_errors.email}</div>
                    }
                </div>
                <div className="form__field">
                    <label>Password</label>
                    <input id="register-password" type="password" name="password"/>
                    {
                        this.state.registration_form_errors.password &&
                        <div className="error">{this.state.registration_form_errors.password}</div>
                    }
                </div>
                <div className="form__field">
                    <label>Confirm Password</label>
                    <input id="confirm-password" type="password" name="confirm-password"/>
                    {
                        this.state.registration_form_errors.password_confirmation &&
                        <div className="error">{this.state.registration_form_errors.password_confirmation}</div>
                    }
                    <button type="submit" className="yellow-btn">Register</button>
                </div>
            </form>
        )
    }

    async checkLicenseKey() {
        let dataURL = "https://onamfc.com/api/check-lk";

        await axios.post(dataURL, {license_key: this.state.license_key_value}).then(response => {
            // console.log('inside', response)
            this.setState({
                key_valid: true
            })
        }).catch(er => {
            this.setState({
                license_key_error_msg: er.response.data.status,
                license_key_error: true
            })
        });


    }

    convertToUppercase(e) {
        this.setState({
            license_key_value: e.target.value.toUpperCase()
        })
    }

    generateLicenseKeyBox() {
        return (
            <div className="license-key">
                <p>Need a license key? You can purchase one <a href="https://marriage365.com/product/happily-ever-after-online-premarital-course/">here</a></p>
                <div>
                    <div className="form__field">
                        <label>Enter License Key</label>
                        <input id="license_key"
                               type="text"
                               name="license_key"
                               value={this.state.license_key_value}
                               onChange={this.convertToUppercase}
                               maxLength={this.maxLicenseKeyLimit}/>
                        <button type="submit" className="yellow-btn" onClick={this.checkLicenseKey.bind(this)}>Validate
                            Key
                        </button>
                    </div>
                    {
                        this.state.license_key_error &&
                        <div className="form__field error">
                            {this.state.license_key_error_msg} If you feel that you are reaching this message in error,
                            please contact us at help@marriage365.org
                        </div>
                    }
                </div>
            </div>

        )
    }

    render() {
        return (
            <div id="register-page">
                <div className="container">
                    <div className="image-container">
                        <img src={logo} alt="Happily Ever After Logo"/>
                    </div>
                    <div id="register-form-container">
                        <div className="title">Already a Member? <Link to="/login">Log in here</Link></div>
                        <h3>HAPPILY EVER AFTER is a self-paced, online premarital course designed by Marriage365 for
                            seriously dating, engaged, and newlywed couples.</h3>

                        {
                            this.state.key_valid ? this.generateForm() : this.generateLicenseKeyBox()
                        }
                    </div>
                </div>
            </div>
        )
    }
}

export default Register;
